var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"mb-6"},[_c('info-responsible-payment',{staticClass:"mb-5"}),(!_vm.checkIfPlanIsFree)?[_c('cupom'),_c('v-divider',{staticClass:"my-6"}),_c('payment-method')]:_c('free-plan')],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }